import { Observable } from "rxjs";
import AzureService from "src/app/shared/services/azure.service";
import { environment } from "src/environments/environment";

export default class WhitelabelUploadHelper {
    private azureService!: AzureService;

    private container = environment.azure.whitelabel.container;

    private storageEndpoint = environment.azure.whitelabel.storageEndpoint;

    public constructor(azureService: AzureService){
        this.azureService = azureService;
    }

    public uploadMany(file: File[], path: string) {
        let many$: Observable<any>[] = [];
        file.forEach(f => {
            many$.push(this.azureService.uploadBlob({
                blobName: `${path}/${f.name}`,
                container: this.container,
                file: f,
                storageEndpoint: this.storageEndpoint
            }));
        });

        return many$;
    }

    public uploadSingle(file: File, path: string) {
        return this.azureService.uploadBlob({
            blobName: `${path}/${file.name}`,
            container: this.container,
            file: file,
            storageEndpoint: this.storageEndpoint
        });
    }
}
